import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateCompany($companyId: ID!, $attributes: CompanyAttributes!) {
    updateCompany(companyId: $companyId, attributes: $attributes) {
      company {
        id
        ...UpdatedCompany
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedCompany on Company {
    id
    name
    address1
    address2
    address3
    city
    county
    postcode
    vatNumber
    companyNumber
    phoneNumber
    domain
    email
    locale
    showPricesOnWebsite
  }
`
